export namespace FareCalculatorsConstants {
  export const DEFAULT_TNC_CALCULATOR = 'Default TNC Calculator';
  export const DEFAULT_LOAD_AND_MILEAGE_CALCULATOR = 'Default Load and Mileage Calculator';
  export const DEFAULT_GRTC_CALCULATOR = 'GRTC Calculator';
  export const BWICAR_TNC_CALCULATOR = 'BWICAR Calculator';
  export const PACE_TNC_CALCULATOR = 'PACE Calculator';
  export const PACERAP_TNC_CALCULATOR = 'PACERAP Calculator';
  export const ANNE_ARUNDEL_TNC_CALCULATOR = 'ANNE ARUNDEL Calculator';
}
